import { QUERY_KEY, MUTATION_KEY } from "constants/globalConstants";
import UserService from "apiService/permissions";
import { useMutation, useQueryClient } from "react-query";
import toast from "react-hot-toast";

const useUpdateRole = (setShowEditForm) => {
  const queryClient = useQueryClient();
  return useMutation(
    [MUTATION_KEY.UPDATE_ROLE],
    (data) => UserService.updateRole(data),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QUERY_KEY.GET_ROLES);
        setShowEditForm(false)
        toast.success('Role updated successfully')
      },
      onError: (error) => {
        toast.error(error.response.data.message)
    },
    }
  );
};

export default useUpdateRole